import { retrieveRawInitData } from '@tma.js/sdk-react'

export function retrieveTelegramUserId(): number | null {
	try {
		const raw = retrieveRawInitData()
		if (!raw) return null
		const userRaw = new URLSearchParams(raw).get('user')
		if (!userRaw) return null
		const user = JSON.parse(userRaw) as { id?: unknown }
		return typeof user.id === 'number' ? user.id : null
	} catch {
		return null
	}
}
